module.exports = __webpack_public_path__ + "videos/ramadan-banner.f641ca1.mp4";